export default __webpack_public_path__ + "static/media/screen3.d502f669.png";